<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="vocational">
				<div class="top" style="width: 100vw; height: 53.333333vw">
					<el-carousel trigger="click" height="53.333333vw">
						<el-carousel-item v-for="(item, index) in topList" :key="index">
							<img :src="webImg + item + imgCut(1000, 530, 'r')" alt="" srcset="" style="width: 100vw;!important; height:53.333333vw;" @dragstart.prevent />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="card">
					<div class="card-content">
						<div class="navigation">
							<div class="navigationItem">
								<img src="../assets/home.png" alt="" @dragstart.prevent />
								<span @click="toTopImg()">首页</span>
								<span class="arrow">></span>
								<span>{{ info.title }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-content">
						<div class="tabbar">
							<div class="item active">
								<div class="txt">{{ info.title }}</div>
								<div class="line"></div>
							</div>
						</div>
						<div class="nav" v-if="list && list.length > 0">
							<div style="position: relative">
								<div class="navMain">
									<div @click="scrollTo(`label-${item.id}`)" v-for="(item, index) in list" class="navMainItem" :class="{ navMainItem1: count == index }">
										<div v-html="item.name"></div>
									</div>
								</div>
							</div>
						</div>
						<template v-if="groupList && groupList.length">
							<div class="navImg" v-for="(item, index) in groupList">
								<div class="navImgLable" :ref="`label-${item[0].typeName}`">{{ item[0].oneTypeName }}</div>
								<div class="navImgList">
									<div class="navImgItem" v-for="(sub, i) in item" @click="viewDetail(sub)">
										<img :src="webImg + sub.picture + imgCut(345, 338)" alt="" @dragstart.prevent />

										<div class="navMainTitle txt-ellipsis-1">{{ sub.title }}</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="card">
					<div class="card-content">
						<!-- <div class="net" v-if="info.link && checkURL(info.link)">
							<a :href="info.link">{{ info.link }}</a>
						</div>
						<div class="net" v-if="info.link && !checkURL(info.link)">
							<a :href="'http://' + info.link">{{ info.link }}</a>
						</div> -->
						<div class="introduce" v-if="info.content" v-html="formatRichText(info.content)"></div>
						<div class="jx" v-for="(item, index) in info.label" v-if="info.label && info.label.length > 0">
							<div style="display: flex">
								<div class="img-box">
									<img src="../assets/jx.png" alt="" @dragstart.prevent />
								</div>
								<div class="txt">{{ item.label }}</div>
							</div>
							<div v-for="(item1, index) in item.children">
								<div class="txt">{{ item1.label }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="vocational">
				<div class="top" style="width: 100%; height: 10vw">
					<el-carousel trigger="click" height="10vw">
						<el-carousel-item v-for="(item, index) in topList" :key="index">
							<img :src="webImg + item + imgCut(1920, 251, 'r')" alt="" srcset="" style="width: 100%;!important; height:10vw;" @dragstart.prevent />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="main">
					<div class="nav" v-if="groupList && groupList.length > 1">
						<div class="navMain">
							<div class="navMain-header">产品分类</div>
							<div class="navMain-body" ref="container">
								<div v-for="(item, index) in groupList" class="navMainItem">
									<div class="navMainItem-label" :ref="`navMainItem-label-${item[0].typeName}`" @click="scrollTo(`label-${item[0].typeName}`)">
										{{ item[0].oneTypeName }}
									</div>
									<div class="navMainItem-subItem" v-for="(sub, i) in item" @click="viewDetail(sub)">{{ sub.title }}</div>
									<div class="navMainItem-line" v-if="index < groupList.length - 1"></div>
								</div>
							</div>
						</div>
					</div>
					<div class="navImg-container" v-if="groupList && groupList.length">
						<el-tabs class="vocational-tabs" v-model="activeName">
							<el-tab-pane label="列表" name="list">
								<div class="navigation">
									<div class="navigationItem">
										<img src="../assets/home.png" alt="" />
										<span @click="toTopImg()" style="cursor: pointer" @dragstart.prevent>首页</span>
										<span style="color: black">></span>
										<span>{{ info.title }}</span>
									</div>
								</div>
								<div class="introduce" v-if="info.content" v-html="formatRichText(info.content)"></div>
								<div class="jx" v-for="(item, index) in info.label" v-if="info.label && info.label.length > 0">
									<div style="display: flex; align-items: center">
										<img src="../assets/jx.png" alt="" @dragstart.prevent />
										{{ item.label }}
									</div>
									<div v-for="(item1, index) in item.children" style="margin-left: 30px; margin-top: 10px">
										<div style="display: flex; align-items: center">{{ item1.label }}</div>
									</div>
								</div>
								<div class="navImg" v-for="(item, index) in groupList">
									<div class="navImgLable" :ref="`label-${item[0].typeName}`">{{ item[0].oneTypeName }}</div>
									<div class="navImgList">
										<div class="navImgItem" v-for="(sub, i) in item" @click="viewDetail(sub)">
											<img :src="webImg + sub.picture + imgCut(288, 338)" alt="" @dragstart.prevent />
											<div class="navMainTitle">
												<div class="txt-ellipsis-2">{{ sub.title }}</div>
											</div>
										</div>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="详情" name="details">
								<div class="navigation">
									<div class="navigationItem">
										<img src="../assets/home.png" alt="" />
										<span @click="toTopImg()" style="cursor: pointer" @dragstart.prevent>首页</span>
										<template v-if="viewInfo.businessTitle">
											<span style="color: black">></span>
											<span @click="barClick(0)">{{ viewInfo.businessTitle }}</span>
										</template>
										<template v-if="viewInfo.oneTypeName">
											<span style="color: black">></span>
											<span>{{ viewInfo.oneTypeName }}</span>
										</template>
										<span style="color: black">></span>
										<span>{{ viewInfo.title }}</span>
										
										<span style="margin-left: auto;cursor: pointer;" @click="back">返回</span>
										<span style="color: #1979b7;cursor: pointer;" @click="back">></span>
									</div>
								</div>
								<div class="details-main" v-if="viewInfo.content">
									<div class="rich-container" v-html="formatRichText(viewInfo.content)"></div>
								</div>
							</el-tab-pane>
						</el-tabs>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { businessDetail, businessOneList, businessOne, businessTwo, businessThree } from '../api/api';
import _ from 'lodash';
export default {
	data() {
		return {
			list: [], //二级菜单数组
			groupList: [], //
			id: this.$route.query.id || '', //二级菜单数组id
			count: 0,
			pageNum: 1,
			pageSize: 5,
			info: {},
			listOne: [],
			listTwo: [],
			listThree: [],
			num: 1,
			totalNum: 1,
			topList: [],
			moduleOneTotalNum: 1,
			moduleOneTotal: 1,
			screenWidth: '',
			isManualScroll: false,
			// 你想要向上偏移的像素值
			labelOffset: 0,
			// 右侧显示的内容 list details 
			activeName: 'list',
			// 详情
			viewInfo: {},
			// 列表的滚动高度
			scrollTop: 0
		};
	},
	created() {
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth, 'this.screenWidth');
		this.count = 0;
		this.getBusinessDetail(); //二级菜单

		// 监听页面滚动
		window.addEventListener('scroll', this.handleScroll);
	},
	watch: {
		$route(to, from) {
			this.count = 0;
			this.id = to.query.id;
			this.getBusinessDetail(); //二级菜单
		}
	},
	mounted() {},
	methods: {
		// 返回列表
		back() {
			this.activeName = 'list'
			this.$nextTick(() => {
				window.scrollTo({
					top: this.scrollTop
				});
			})
		},
		handleScroll() {
			if (this.isMobile) {
			} else {
				if (this.activeName == 'list') {
					if (!this.isManualScroll) {
						return this.handleScrollThrottle();
					} else {
						return this.handleScrollDebounce();
					}
				}
			}
		},
		handleScrollThrottle: _.throttle(
			function () {
				console.log('this.groupList: ', this.groupList);
				// 获取垂直滚动距离
				const scrollY = window.scrollY || window.pageYOffset;
				const offset = 20; // 你想要向上偏移的像素值

				for (var i = 0; i < this.groupList.length; i++) {
					let index = this.groupList.length - i - 1;
					if (scrollY > this.groupList[index][0].distanceFromTop) {
						console.log('index1: ', index);
						let container = this.$refs.container;
						container.scrollTo({
							top: this.groupList[index][0].navMainItemDistanceFromTop - offset,
							behavior: 'smooth'
						});
						break;
					}
				}
				console.log('垂直滚动距离:', scrollY);
			},
			150,
			{
				leading: false,
				trailing: true
			}
		),
		handleScrollDebounce: _.debounce(
			function () {
				console.log('this.groupList: ', this.groupList);
				// 获取垂直滚动距离
				const scrollY = window.scrollY || window.pageYOffset;
				const offset = 20; // 你想要向上偏移的像素值

				for (var i = 0; i < this.groupList.length; i++) {
					let index = this.groupList.length - i - 1;
					if (scrollY > this.groupList[index][0].distanceFromTop) {
						console.log('index2: ', index);
						let container = this.$refs.container;
						container.scrollTo({
							// 实际还没滚动到此元素所以+1
							top: this.groupList[index + 1][0].navMainItemDistanceFromTop - offset,
							behavior: 'smooth'
						});
						break;
					}
				}
				this.isManualScroll = false;
			},
			150,
			{
				leading: false,
				trailing: true
			}
		),
		viewDetail(item) {
			console.log('item: ',item);
			this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			window.scrollTo({
				top: 0
			});
			this.viewInfo = item
			this.activeName = 'details'
			// this.$router.push({
			// 	path: '/detail',
			// 	query: {
			// 		viewInfo: item
			// 	}
			// });
		},
		scrollTo(refName) {
			console.log(refName);
			console.log('this.$refs: ', this.$refs);
			const element = this.$refs[refName][0];
			if (element) {
				if (this.isMobile) {
					this.labelOffset = 60;
				} else {
					this.labelOffset = 40;
				}
				const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
				const offsetPosition = elementPosition - this.labelOffset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});

				if (this.isMobile) {
				} else {
					this.isManualScroll = true;
				}

				// 使用原生JS实现平滑滚动
				// element.scrollIntoView({ behavior: 'smooth' });

				// 或者使用window.scrollTo
				// window.scrollTo({
				//   top: element.offsetTop,
				//   behavior: 'smooth'
				// });
			}
		},
		//二级菜单
		getBusinessDetail() {
			console.log('mihahah');
			businessDetail(this.id).then((res) => {
				this.topList = res.data.picture.split(',');
				res.data.label = JSON.parse(res.data.label);
				this.info = res.data;
				this.getBusinessOneList(res.data.id);
			});
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		//模块一列表
		getBusinessOneList() {
			businessOneList(this.id).then((res) => {
				this.list = res.data;
				// this.groupList = res.groupList;
				this.moduleOneTotal = res.total;
				this.moduleOneTotalNum = Math.ceil(res.total / 5);

				//模块一详情
				this.getBusinessOne();
			});
		},
		//模块一详情
		getBusinessOne() {
			this.groupList = [];
			businessOne(this.id).then((res) => {
				this.list.forEach((v) => {
					for (let key in res.groupList) {
						console.log('key: ', key);
						if (v.id == res.groupList[key][0].typeName) {
							this.groupList.push(res.groupList[key]);
							break;
						}
					}
				});
				this.$nextTick(() => {
					this.activeName = 'list'
					this.$nextTick(() => {
						window.scrollTo({
							top: 0
						});
						if (this.isMobile) {
						} else {
							this.$nextTick(() => {
								this.getNavImgLableDistance();
							});
						}
					})
				})
			});
		},
		// 获取标题离顶部的距离
		getNavImgLableDistance() {
			let parent = this.$refs.container;
			for (var i = 0; i < this.groupList.length; i++) {
				const element = this.$refs[`label-${this.groupList[i][0].typeName}`][0];
				const rect = element.getBoundingClientRect();
				this.groupList[i][0].distanceFromTop = rect.top;
				const child = this.$refs[`navMainItem-label-${this.groupList[i][0].typeName}`][0];
				this.groupList[i][0].navMainItemDistanceFromTop = this.getDistanceToContainerTop(child, parent);
			}
		},
		getDistanceToContainerTop(child, parent) {
			let distance = 0;
			const parentRect = parent.getBoundingClientRect();
			const childRect = child.getBoundingClientRect();
			distance = childRect.top - parentRect.top;
			return distance;
		},
		//模块一详情点击
		navMainClick(index) {
			this.count = index;
			this.getBusinessOne(this.list[index].id);
		},
		aLeftClick() {
			if (this.num <= 1) {
				return (this.num = this.totalNum);
			}
			this.num--;
		},
		aRight() {
			if (this.num >= this.totalNum) {
				return (this.num = 1);
			}
			this.num++;
		},
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			});
		}
	}
};
</script>

<style lang="scss">
	.rich-container {
		p {
			margin: 0;
		}
	}
	.vocational-tabs {
		.el-tabs__header {
			display: none !important;
		}
	}
</style>
<style scoped lang="scss">
.device-mobile {
	background: #f5f5f5;

	.vocational {
		width: 100vw;

		.card {
			width: 100%;
			margin-bottom: 0.133333rem;
			background: #ffffff;
			padding-bottom: 0.533333rem;

			.card-content {
				width: 9.466667rem;
				margin: 0 auto;

				.navigation {
					width: 100%;

					// background: #F5F5F5;
					// padding: 0 0.333333rem;
					.navigationItem {
						display: flex;
						align-items: center;
						padding-top: 0.36rem;
						// height: 1.066667rem;
						color: #1979b7;
						font-size: 0.333333rem;

						.arrow {
							color: #030303;
							margin: 0 0.133333rem;
						}

						img {
							width: 0.333333rem;
							height: 0.333333rem;
							margin-right: 0.133333rem;
						}
					}
				}

				.tabbar {
					width: 100%;
					height: 1.653333rem;
					display: flex;
					align-items: center;

					.item {
						position: relative;
						display: flex;
						flex-direction: column;
						margin-right: 0.4rem;

						&.active {
							.txt {
								font-size: 0.453333rem;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: bold;
								color: #000000;
							}

							.line {
								display: block;
							}
						}

						.txt {
							font-size: 0.4rem;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #000000;
						}

						.line {
							position: absolute;
							bottom: -0.266667rem;
							display: none;
							margin-top: 0.213333rem;
							width: 1.2rem;
							height: 0.053333rem;
							background: #007cc3;
							border-radius: 0px 0px 0px 0px;
							opacity: 1;
						}
					}
				}

				.net {
					width: 1210px;
					margin: 0 auto;
					font-size: 21px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
					margin-top: 28px;

					a {
						text-decoration: none;
						color: #000000;
					}

					a:hover {
						text-decoration: underline;
						color: #0076be;
					}
				}

				.introduce {
					font-size: 0.346667rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #545454;
					margin: 0.4rem 0;
				}

				.jx {
					margin-top: 12px;

					.img-box {
						display: flex;
						align-items: center;
						height: 0.533333rem;

						img {
							width: 0.32rem;
							height: 0.32rem;
							margin-right: 0.266667rem;
						}
					}

					.txt {
						font-size: 0.346667rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: bold;
						color: #000000;
						line-height: 0.533333rem;
					}
				}

				.nav {
					width: 100%;
					display: flex;
					margin: 0 auto;
					justify-content: center;
					align-items: center;

					img {
						width: 21px;
						height: 25px;
						cursor: pointer;
					}

					.navMain {
						width: 100%;
						display: flex;
						flex-wrap: wrap;

						.navMainItem {
							// width: 204px;
							min-width: 1.76rem;
							height: 0.853333rem;
							background: #0175c2;
							border-radius: 0px 0px 0px 0px;
							opacity: 1;
							margin-right: 0.133333rem;
							margin-bottom: 0.266667rem;
							box-sizing: border-box;
							padding: 0.133333rem;

							font-size: 0.373333rem;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #ffffff;
						}

						.navMainItem1 {
							background: #0175c2;
						}
					}
				}

				.navImg {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					.navImgLable {
						font-size: 0.373333rem;
						font-weight: bold;
						margin-top: 0.533333rem;
					}

					.navImgList {
						display: flex;
						justify-content: space-between;
						flex-wrap: wrap;

						.navImgItem {
							width: 4.6rem;
							height: 4.506667rem;
							position: relative;
							margin-top: 0.333333rem;
							border-radius: 0.266667rem;
							overflow: hidden;

							.navMainTitle {
								position: absolute;
								bottom: 0;
								width: 100%;
								height: 0.773333rem;
								box-sizing: border-box;
								padding: 0 0.133333rem;
								background: rgba(0, 0, 0, 0.4);
								display: flex;
								justify-content: center;
								align-items: center;
								font-size: 0.32rem;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #ffffff;
								text-align: center;
							}

							img {
								object-fit: cover;
								width: 100%;
								height: 100%;
							}
						}
					}

					.navImgItem:nth-child(3n) {
						margin-right: 0;
					}
				}

				.technology {
					width: 100%;
					display: flex;
					flex-direction: column;
					position: relative;

					.technologyName {
						width: 100%;
						background: #3a3939;
						box-sizing: border-box;
						position: relative;

						.angin {
							font-size: 0.4rem;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: bold;
							color: #ffffff;
							margin-bottom: 0.266667rem;
						}

						.anginText {
							font-size: 0.32rem;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #828282;
						}

						.anginImg {
							// position: absolute;
							float: right;
							display: flex;
							align-items: center;
							font-size: 0.32rem;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #ffffff;

							span {
								font-size: 0.2rem;
							}

							.el-icon-arrow-left {
								color: #2a2a2a;
							}

							.el-icon-arrow-right {
								color: #2a2a2a;
							}

							.aLeft {
								width: 0.733333rem;
								height: 0.733333rem;
								background: #ffffff;
								margin-left: 0.266667rem;
								display: flex;
								justify-content: center;
								align-items: center;
								cursor: pointer;
							}

							.aRight {
								width: 0.733333rem;
								height: 0.733333rem;
								background: #ffffff;
								display: flex;
								justify-content: center;
								align-items: center;
								cursor: pointer;
							}
						}
					}

					.technologyImg {
						width: 100%;
						box-shadow: 0 0 16px 5px #e0dedf;

						img {
							width: 100%;
							height: 100%;
							box-shadow: 0 0 16px 5px #e0dedf;
						}
					}
				}

				.contact {
					display: flex;
					flex-wrap: wrap;
					justify-content: space-between;

					.listText {
						margin-right: 30px;
						margin-top: 20px;
						width: 370px;
						height: 404px;
						position: relative;
						border-radius: 10px;
						overflow: hidden;

						img {
							transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
						}
					}

					.nameNavMainTitle {
						position: absolute;
						left: 0;
						bottom: 0;
						width: 100%;
						height: 58px;
						background: rgba(0, 0, 0, 0.4);
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 21px;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #ffffff;
						border-radius: 0 0 10px 10px;
					}
				}
			}
		}
	}

	.el-carousel__container {
		height: 25.17vw !important;
		//   width: 100vw;
	}
}

.device-pc {
	position: relative;
	z-index: 2;
	margin-bottom: -30px;
	background: #ffffff;
	.vocational {
		padding-bottom: 20px;
		// width: 100vw;
	}

	.top {
		height: 427px;
		// width: 100vw;

		.topText {
			font-size: 65px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			margin-top: -230px;
			margin-left: 105px;
		}

		// div {
		//     font-size: 65px;
		//     font-family: PingFang SC-Medium, PingFang SC;
		//     font-weight: 500;
		//     color: #FFFFFF;
		//     margin-top: -230px;
		//     margin-left: 105px;
		// }

		img {
			height: 427px;
			// width: 100vw;
		}
	}

	.name {
		width: 1210px;
		margin: 0 auto;
		font-size: 32px;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #000000;
		margin-top: 60px;

		.angin {
			font-size: 29px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			// width: 17vw;
		}

		.anginText {
			font-size: 16px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #ffffff;
			margin-top: 28px;
			line-height: 33px;
			// width: 17vw;
		}
	}

	.line {
		width: 1210px;
		margin: 0 auto;
		margin-top: 40px;

		.lineItem {
			width: 63px;
			height: 5px;
			background: #0175c2;
		}
	}

	.net {
		width: 1210px;
		margin: 0 auto;
		font-size: 21px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-top: 28px;

		a {
			text-decoration: none;
			color: #000000;
		}

		a:hover {
			text-decoration: underline;
			color: #0076be;
		}
	}

	.division {
		// width: 100vw;
		height: 10px;
		background: #f2f2f2;
		margin-top: 50px;
	}

	.main {
		display: flex;
		width: 1210px;
		margin: 0 auto;
		// overflow: auto;
		.nav {
			position: sticky;
			top: 20px;
			z-index: 99;
			align-self: flex-start;
			margin-top: -68px;
			width: 256px;
			margin-right: 40px;
			.navMain {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				cursor: pointer;

				.navMain-header {
					height: 68px;
					background: #1673c3;
					border-radius: 20px 20px 0px 0px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 28px;
					color: #ffffff;
					line-height: 28px;
				}

				.navMain-body {
					box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.13);
					max-height: calc(100vh - 68px - 20px);
					overflow-y: auto;
					.navMainItem {
						// width: 204px;
						display: flex;
						flex-direction: column;
						.navMainItem-label {
							margin-top: 20px;
							box-sizing: border-box;
							padding: 0 20px 0 30px;
							margin-bottom: 16px;
							font-family: PingFang SC, PingFang SC;
							font-weight: bold;
							font-size: 18px;
							color: #000000;
							line-height: 18px;
							position: relative;
							display: flex;
							align-items: center;
							&::before {
								content: '';
								width: 8px;
								height: 8px;
								background: #1673c3;
								border-radius: 50%;
								position: absolute;
								left: 16px;
							}
						}
						.navMainItem-subItem {
							margin-bottom: 16px;
							box-sizing: border-box;
							padding: 0 20px 0 30px;
							font-family: PingFang SC, PingFang SC;
							font-weight: 500;
							font-size: 16px;
							color: #666666;
							text-align: justify;
						}
						.navMainItem-line {
							margin-left: 16px;
							margin-right: 10px;
							height: 1px;
							background-color: #ededed;
						}
					}
				}

				.navMainItem1 {
					background: #0175c2;
				}
			}
		}

		.navImg-container {
			flex: 1;
			.navigation {
				// width: 100vw;
				display: flex;
				align-items: center;

				.navigationItem {
					flex: 1;
					display: flex;
					align-items: center;
					// margin-top: 15px;
					height: 36px;
					line-height: 36px;
					margin-bottom: 20px;
					padding-top: 15px;
					box-sizing: border-box;
					color: #1979b7;
					font-size: 20px;
				}

				img {
					width: 20px;
					height: 20px;
					margin-right: 7px;
				}
			}

			.introduce {
				font-size: 16px;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #545454;
				margin-top: 32px;
				margin-bottom: 12px;
			}

			.jx {
				margin-top: 12px;

				img {
					width: 17px;
					height: 17px;
					margin-right: 10px;
				}

				font-size: 14px;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #000000;
			}

			.navImg {
				display: flex;
				flex-direction: column;
				flex-wrap: wrap;
				// justify-content: space-between;

				.navImgLable {
					margin-top: 40px;
					margin-bottom: 15px;
					font-family: PingFang SC, PingFang SC;
					font-weight: bold;
					font-size: 26px;
					color: #000000;
					line-height: 26px;
				}

				.navImgList {
					display: flex;
					flex-wrap: wrap;
					margin-left: -25px;

					.navImgItem {
						width: 283px;
						// width: 440px;
						height: 338px;
						position: relative;
						margin-top: 25px;
						margin-left: 25px;
						overflow: hidden;
						border-radius: 10px;
						box-shadow: 0 0 16px 5px #e0dedf;

						.navMainTitle {
							position: absolute;
							bottom: 0;
							width: 100%;
							height: 76px;
							box-sizing: border-box;
							padding: 0 15px;
							background: rgba(0, 0, 0, 0.4);
							display: flex;
							justify-content: center;
							align-items: center;
							border-radius: 0 0 10px 10px;
							div {
								font-family: PingFang SC, PingFang SC;
								font-weight: bold;
								font-size: 20px;
								color: #ffffff;
								text-align: center;
							}
						}

						img {
							object-fit: cover;
							width: 100%;
							height: 100%;
							transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
							border-radius: 10px;
							box-shadow: 0 0 16px 5px #e0dedf;
						}
					}
				}

				// .navImgItem:nth-child(3n) {
				// 	margin-right: 0;
				// }

				.navImgItem:hover {
					img {
						transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
						transform: scale(1.1);
					}
				}
			}
			
			.rich-container {
				font-size: 0.426667rem;
				line-height: 2;
				text-indent: 24pt;
			}
		}
	}

	.technology {
		// width: 100vw;
		margin: auto;
		height: 460px;
		display: flex;
		margin-top: 20px;
		position: relative;

		.technologyName {
			// width: 40vw;
			background: #3a3939;
			// display: flex;
			// flex-direction: column;
			// // justify-content: center;
			// align-items: center;
			padding: 53px 43px 0 108px;
			box-sizing: border-box;
			position: relative;
			//     box-shadow: 0 0 16px 5px #e0dedf;
		}

		.technologyImg {
			// width: 60vw;
			// width: 839px;
			height: 100%;
			box-shadow: 0 0 16px 5px #e0dedf;

			img {
				// width: 100%;
				height: 100%;
				box-shadow: 0 0 16px 5px #e0dedf;
			}
		}

		.anginImg {
			position: absolute;
			right: 0;
			bottom: 0px;
			display: flex;
			align-items: center;
			font-size: 24px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #ffffff;

			span {
				font-size: 15px;
			}

			.el-icon-arrow-left {
				color: #2a2a2a;
			}

			.el-icon-arrow-right {
				color: #2a2a2a;
			}

			.aLeft {
				width: 55px;
				height: 55px;
				background: #ffffff;
				margin-left: 35px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}

			.aRight {
				width: 55px;
				height: 55px;
				background: #ffffff;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;
			}

			.aLeft:hover,
			.aRight:hover {
				background: #0175c2;
			}
		}

		.angin {
			font-size: 29px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			width: 405px;
		}

		.anginText {
			font-size: 16px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #ffffff;
			margin-top: 28px;
			line-height: 33px;
			width: 405px;
		}
	}

	.listText {
		margin-right: 30px;
		margin-top: 20px;
		width: 370px;
		height: 404px;
		position: relative;
		border-radius: 10px;
		overflow: hidden;

		img {
			transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
		}
	}

	.listText:hover {
		// transform: scaleX(20%);
		img {
			transition: transform 2s cubic-bezier(0.23, 1, 0.32, 1);
			transform: scale(1.1);
		}
	}
	.el-carousel__container {
		height: 25.17vw !important;
		//   width: 100vw;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/vocational.vue